import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useYandexMetrikaContext } from "@/contexts/YandexMetrikaContext";

export const YandexMetrikaTracker = () => {
  const location = useLocation();
  const { hit } = useYandexMetrikaContext();

  useEffect(() => {
    // Отправляем хит при изменении маршрута
    hit(window.location.href, {
      title: document.title,
      referer: document.referrer,
    });
  }, [location.pathname, location.search, hit]);

  return null;
};
